/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/VBep20.json';
import { VBep20 } from 'libs/contracts/generated/infos/contractTypes';
import { useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetVBep20ContractInput {
  address: string;
  signerOrProvider: Signer | Provider;
}

export const getVBep20Contract = ({ signerOrProvider, address }: GetVBep20ContractInput) =>
  new Contract(address, abi, signerOrProvider) as VBep20;

interface UseGetVBep20ContractInput {
  passSigner: boolean;
  address: string;
  chainId?: ChainId;
}

export const useGetVBep20Contract = ({
  passSigner = false,
  address,
  chainId,
}: UseGetVBep20ContractInput) => {
  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getVBep20Contract({
            address,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, address],
  );
};
